export const LOADING_IDS = {
    ORDER: 'order',
    WORKSHEETS: 'worksheets',
    ORDER_OBJECTS: 'orderObjects',
};
